import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { AuthService } from 'src/app/@api/services';
//import { StreamingService } from 'src/app/streaming.service';
import { take } from 'rxjs/operators';
import { AdaptiveMode } from '@progress/kendo-angular-dateinputs';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { GetSupplierQueryResponse, CreateSupplierCommand, UpdateSupplierCommand } from '../../interfaces/interfaces';
import { SuppliersService } from '../suppliers.service';
import { AuthService } from 'src/app/services/auth.service';
import { StreamingService } from 'src/app/services/streaming.service';
//import { ConsoleReporter } from 'jasmine';
//import { Console } from 'console';

@Component({
  selector: 'sdc-maintain-supplier',
  templateUrl: './maintain-supplier.component.html',
  styleUrls: ['./maintain-supplier.component.scss']
})
export class MaintainSupplierComponent implements OnInit {

  isLoading = true;
  isUpdate = false;
  supplierForm: UntypedFormGroup;
  processDate = false;
  userName: string;
  role: string;

  public valueJob: Date = new Date(2019, 5, 1, 22);
  public valueStart: Date = new Date(2019, 5, 1, 22);
  public valueComplete: Date = new Date(2019, 5, 1, 22);
  public format = "MM/dd/yyyy HH:mm";
  public adaptiveMode: AdaptiveMode = "auto";

  currentDate = new Date();
  createSupplierCommand: CreateSupplierCommand;
  updateSupplierCommand: UpdateSupplierCommand;

  constructor(
    @Inject(MAT_DIALOG_DATA) public repair: GetSupplierQueryResponse,
    public dialogRef: MatDialogRef<MaintainSupplierComponent>,
    private supplierService: SuppliersService,
    private authService: AuthService,
    private streamingService: StreamingService,
    private formBuilder: UntypedFormBuilder,
    private matSnackBar: MatSnackBar,
    private dialog: MatDialog,
    private datePipe: DatePipe,
  ) {
    if (this.repair.id > 0) {
      this.isUpdate = true;
    }
   }

  ngOnInit(): void {
    this.userName = localStorage.getItem('currentUserName');
    //this.role = localStorage.getitem('currentRole');
    this.supplierForm = this.formBuilder.group({
      title: [null, Validators.required],
      supplierAddress : [null],
      supplierWebsite: [null],
      supplierEmail: [null],
      supplierPhone: [null],
      supplierContact: [null],
      description: [null],
    },);

    if (this.isUpdate) {
      this.supplierService.getSupplier({id : this.repair.id}).pipe(take(1)).subscribe({
        next: (response: GetSupplierQueryResponse) => {
          //this.repair = response;
          //alert("Before reponse Patch");
          this.supplierForm.patchValue(response);
          //alert("After reponse Patch");
          //this.repairForm.controls.dateStarted.setValue = new Date(this.repair.dateStarted);
          const count = {};
          //alert(response.photos);
        },
        error: (error: HttpErrorResponse) => {
          alert(error);
          this.isLoading = false;
        }
      });
      
    }
    else {
    }
    this.isLoading = false;
  }

  public parseObjectDates(target: any): any {
    const result = Object.assign({}, target);

    Object.keys(result).forEach((key) => {
      const date = new Date(result[key]);
      if (!isNaN(date.getTime())) {
        result[key] = date;
      }
    });

    return result;
  }

  addSupplier(): void {
    this.isLoading = true;
    this.createSupplierCommand = this.supplierForm.value;   

    this.supplierService.createSupplier(this.createSupplierCommand).pipe(take(1)).subscribe({
      next: () => {
        this.isLoading = false;
        this.displayMessage('New supplier created');
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });
  }

  updateSupplier(): void {
    this.isLoading = true;
    this.updateSupplierCommand = this.supplierForm.value;

    this.updateSupplierCommand.id = this.repair.id;
    //alert(this.repairForm.controls.myFiles.value);

    this.updateRepairEvent(this.updateSupplierCommand);
    this.isLoading = false;

  }

  updateRepairEvent(command: UpdateSupplierCommand): void {
    this.supplierService.updateSupplier(command).pipe(take(1)).subscribe({
      next: () => {
        this.isLoading = false;
        this.displayMessage('Supplier updated');
        this.dialogRef.close();
      },
      error: (error: HttpErrorResponse) => {
        alert(error);
        this.isLoading = false;
      }
    });
    
  }

  private displayMessage(message: string): void {
    this.matSnackBar.open(message, 'Close', {
      duration: 7000
    });
  }
}
